// Module
var code = "<template>\n  <div class=\"divider\"></div>\n</template>\n";
// Exports
export default code;